import { PlayArrow } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, Drawer, Grid, IconButton, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SimpleMeasurementDrawerProps } from '../../../@types/ContextProviderRelated';
import { useAnnotations } from '../../../provider/AnnotationsProvider';
import { useSelection } from '../../../provider/SelectionProvider';
import { immersightBlue } from '../../../utils/colors';

const SimpleMeasurementDrawer = (props: SimpleMeasurementDrawerProps): JSX.Element => {
  const { id, open, onClose } = props;
  const { selectedSimpleMeasurement, resetSelection } = useSelection();
  const { deleteMeasurement, measurements } = useAnnotations();
  const intl = useIntl(); // React Intl Hook
  const measurement = measurements[selectedSimpleMeasurement.simpleMeasurementIndex];

  useEffect(() => {
    if (!measurement) {
      onClose();
    }
  }, [selectedSimpleMeasurement.simpleMeasurementIndex, measurement, onClose]);

  const handleCloseDrawer = (): void => {
    onClose();
  };

  const handleDeleteMeasurement = (): void => {
    if (measurement) {
      deleteMeasurement(measurement.id);
      resetSelection();
      onClose();
    }
  };

  return (
    <Drawer
      key={id}
      anchor="right"
      open={open}
      variant={open ? 'permanent' : 'temporary'}
      sx={{
        '& .MuiPaper-root': {
          top: '64px',
          zIndex: 1000,
          width: '340px',
          height: 'calc(100% - 64px)',
        },
      }}
    >
      <Grid container direction="column" p={0}>
        <Grid
          item
          sx={{
            backgroundColor: immersightBlue,
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 0.5,
          }}
        >
          <Box sx={{ marginLeft: '16px' }}>
            <Typography variant="h6" sx={{ textTransform: 'uppercase' }}>
              <FormattedMessage id="SimpleMeasurementDrawer.measurement" />
            </Typography>
          </Box>

          <IconButton
            onClick={handleCloseDrawer}
            sx={{
              color: '#fff',
              '&:hover': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <PlayArrow sx={{ fontSize: 30 }} />
          </IconButton>
        </Grid>
      </Grid>
      {/* Content area below the header */}
      <Grid container item direction="column" spacing={3} p={3}>
        <Grid item>
          <Button variant="contained" startIcon={<DeleteIcon />} onClick={handleDeleteMeasurement} color="error">
            {intl.formatMessage({ id: 'SimpleMeasurementDrawer.delete' })}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default SimpleMeasurementDrawer;